export const LOCATION = {
  center: [37.588144, 55.733842],
  zoom: 8,
};
export const COMMON_LOCATION_PARAMS = { easing: 'linear', duration: 1500 };
